module.exports = __webpack_public_path__ + "static/img/rebuild.8475fa94.jpg";